/**
 * Document entity model exports
 */

import * as mocks from './mocks';

export { default as useDocumentRevisionSearch } from './useDocumentRevisionSearch';
export { store as useDocumentRevisionsStore } from './useDocumentRevisionsStore';
export { createDocumentRevisionsStore } from './createDocumentRevisionsStore';
export { default as useDocumentRefreshStore } from './useDocumentRefreshStore';

// Filter types
export * from './filterTypes';

let _mocks: {
  PENDING_DOCUMENTS: any[];
  APPROVALS: any[];
  VERIFICATIONS: any[];
  REVISIONS: any[];
} | null = null;

function getMocks() {
  if (!_mocks) {
    _mocks = mocks;
  }
  return _mocks;
}

export const PENDING_DOCUMENTS = new Proxy([], {
  get(_, prop) {
    const mockData = getMocks().PENDING_DOCUMENTS;
    if (prop === 'length') return mockData.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return mockData[Number(prop)];
    return (mockData as any)[prop];
  },
}) as unknown as readonly any[];

export const APPROVALS = new Proxy([], {
  get(_, prop) {
    const mockData = getMocks().APPROVALS;
    if (prop === 'length') return mockData.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return mockData[Number(prop)];
    return (mockData as any)[prop];
  },
}) as unknown as readonly any[];

export const VERIFICATIONS = new Proxy([], {
  get(_, prop) {
    const mockData = getMocks().VERIFICATIONS;
    if (prop === 'length') return mockData.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return mockData[Number(prop)];
    return (mockData as any)[prop];
  },
}) as unknown as readonly any[];

export const REVISIONS = new Proxy([], {
  get(_, prop) {
    const mockData = getMocks().REVISIONS;
    if (prop === 'length') return mockData.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return mockData[Number(prop)];
    return (mockData as any)[prop];
  },
}) as unknown as readonly any[];
